import createNumberMask from 'text-mask-addons/dist/createNumberMask'
import emailMask from 'text-mask-addons/dist/emailMask'

const defaultCurrencyMaskOptions = {
  prefix: 'R$ ',
  suffix: '',
  placeholder: 'R$ 00,00',
  includeThousandsSeparator: true,
  thousandsSeparatorSymbol: '.',
  allowDecimal: true,
  decimalSymbol: ',',
  decimalLimit: 2,
  integerLimit: 7,
  allowNegative: false,
  allowLeadingZeroes: false,
}

const Mask = (name:string) => {
  const currencyMask = createNumberMask({
    ...defaultCurrencyMaskOptions,
  })

  switch (name) {
    case 'CPF':
      return [/[1-9]/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '-', /\d/, /\d/]
    case 'CEP':
      return [/[1-9]/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/]
    case 'UF':
      return [/[a-z|A-Z]/, /[a-z|A-Z]/]
    case 'CNPJ':
      return [/[1-9]/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/]
    case 'CURRENCY':
      return currencyMask
    case 'PASSWORD':
      return [/[1-9]/, /\d/, /\d/, /\d/, /\d/, /\d/]
    case 'PHONE_NUMBER':
      return ['(', /[1-9]/, /\d/, ')', ' ', /\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]
    case 'EMAIL':
      return emailMask
    default:
      return null
  }
}

export default Mask
